// Minimal state machine with token-based async guards
export class StateMachine {
  constructor(initial = 'CLOSED', transitionsMap = {}) {
    this._state = initial
    this._token = 0
    this.transitions = transitionsMap
  }

  get state() { return this._state }
  get token() { return this._token }

  // Attempt transition to next; if invalid, no-op
  transitionTo(next, context = {}) {
    const allowed = this.transitions[this._state] || []
    if (!allowed.includes(next)) {
      // Silently ignore invalid transition to preserve behavior
      return { changed: false, state: this._state, token: this._token }
    }
    this._state = next
    this._token++
    if (typeof context.onEnter === 'function') {
      try { context.onEnter(next, this._token) } catch (_) {}
    }
    return { changed: true, state: this._state, token: this._token }
  }
}

